import { SiteHeader } from "../components/site-header"
import { SiteFooter } from "../components/site-footer"
import SupportContent from "../components/support-content"

export default function SupportPage() {
  return (
    <main>
      <SiteHeader />
      <SupportContent />
      <SiteFooter />
    </main>
  )
}
